<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<p>
					<router-link tag="a" :to="{ name : 'admin.courses.index'}" class="button icon-button">
						<img src="../../../assets/images/icons/solid/angle-left-white.svg" width="8" class="mr-1" />
						<span>Back</span>
					</router-link>
				</p>
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mt-2 mb-4 pb-2 pt-2">Create program</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-5">
				<form @submit.prevent="onSubmit">
					<div class="lightgray-content p-3 rounded mb-4">
						<div class="form-group input-content">
							<label>Name</label>
							<input type="text" v-model="course_data.name" class="form-control" v-validate="'required'" name="name">
							<span class="input-error-msg">{{ errors.first('name') }}</span>
						</div>
						<div class="form-group input-content">
							<label>Description</label>
							<input type="text" v-model="course_data.description" class="form-control" v-validate="'required'" name="description">
							<span class="input-error-msg">{{ errors.first('description') }}</span>
						</div>
					</div>
					<div class="text-right">
						<button type="submit" class="button large-button">Submit</button>
					</div>
				</form>
			</div><!--col-->
		</div><!--row-->
	</div>
</template>


<script>
export default {
	data : function(){
		return {
			course_data : {
				name : '',
				description : ''
			}
		}
	},
	methods : {
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {

				if(result){
					this.$store.dispatch('createCourse', this.course_data).then((res) => {

						this.$router.push({ name : 'admin.courses.index' });
					}).catch((error) => {
						
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/courses/AdminCourseCreateComponent.vue